import { gql } from "@apollo/client";

export const UPDATE_EVOLUCION_ASISTENCIAL = gql`
mutation updatePlanCuidadoInEvaluacion($input: AddPlanCuidadoEvaluacionInput!) {
    updatePlanCuidadoInEvaluacion(input: $input){
        idEvaluacion
    }
}`;

export const adaptGestionInicioInput = (idEvaluacion, gestionInicioData) => ({
  idEvaluacion,
  idMDemora: gestionInicioData?.idMDemora,
  observacionMDemora: gestionInicioData?.observacionMDemora,
  idNIngreso: gestionInicioData?.idNIngreso,
  idRechazoNIngreso: gestionInicioData?.idRechazoNIngreso,
  observacionNIngreso: gestionInicioData?.observacionNIngreso
});